
import React, { useState } from "react";
import { useUserPermissions } from "../../../../UserPermissionsContext";

type TeacherData = {
  teacher_id: number;
  building_category: string;
  branch: string;
  full_name: string;
  designation: string;
  no_of_students: number;
  no_of_sed_paid_students: number;
  has_ticket: boolean;
};

interface TeacherCardProps {
  teacherData: TeacherData;
}

const TeacherCard = ({ teacherData, phoneNumber, additionalNumber }: any) => {
  const { userPermissions } = useUserPermissions();
  const [showPhone, setShowPhone] = useState(false);
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  const rows = [
    { label: "Building Category", value: teacherData.building_category },
    { label: "Branch", value: teacherData.branch },
    { label: "Teacher Name", value: teacherData.full_name },
    { label: "Designation", value: teacherData.designation },
    { label: 'Class', value : teacherData.class_name},
    { label: 'Section', value: teacherData.section},
    { label: "No of Students", value: teacherData.no_of_students },
    { label: "SED Paid Students", value: teacherData.no_of_sed_paid_students },
    // { label: "Phone Number", value: phoneNumber.mobile_number}
    // { label: "Ticket", value: teacherData.has_ticket ? "Yes" : "No" },
  ];

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  return (
    <div
      className="card"
      style={{
        width: "100%",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        borderRadius: "8px",
        border: "1px solid #d1d5db",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "16px 20px",
          fontSize: "20px",
          fontWeight: 600,
          color: "#16325c",
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        Teacher Information
      </div>

      {/* Body */}
      <div className="card-body" style={{ padding: "18px" }}>
        {rows.map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "12px",
              padding: "12px 0",
              borderBottom:
                index !== rows.length - 1 ? "1px solid #e5e7eb" : "none",
            }}
          >
            <span
              style={{
                fontWeight: 600,
                color: "#4b5563",
                fontSize: "14px",
              }}
            >
              {row.label}
            </span>

            <span
              style={{
                textAlign: "right",
                color:
                  row.label === "Ticket"
                    ? teacherData.has_ticket
                      ? "green"
                      : "red"
                    : "#1f2937",
                fontWeight: row.label === "Has Ticket" ? 600 : 400,
                fontSize: "14px",
              }}
            >
              {row.value}
            </span>
          </div>
        ))}

        {/* Phone Number Row */}
        {checkPermission("can_view_employee_mobile_number", "teacher") && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 0",
            }}
          >
            <span
              style={{
                fontWeight: 600,
                color: "#4b5563",
                fontSize: "14px",
              }}
            >
              Phone Number
            </span>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <span style={{ fontSize: "14px" }}>
                {showPhone ? phoneNumber?.mobile_number : ""}
              </span>

              <i
                className={showPhone ? "fas fa-eye-slash" : "fas fa-eye"}
                style={{
                  cursor: "pointer",
                  color: "#16325c",
                  fontSize: "16px",
                }}
                onClick={() => setShowPhone(!showPhone)}
              />
            </div>
          </div>
        )}
        {additionalNumber && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 0",
            }}
          >
            <span
              style={{
                fontWeight: 600,
                color: "#4b5563",
                fontSize: "14px",
              }}
            >
              Additional Phone Number
            </span>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <span style={{ fontSize: "14px" }}>
                {showPhoneNumber ? additionalNumber : ""}
              </span>

              <i
                className={showPhoneNumber ? "fas fa-eye-slash" : "fas fa-eye"}
                style={{
                  cursor: "pointer",
                  color: "#16325c",
                  fontSize: "16px",
                }}
                onClick={() => setShowPhoneNumber(!showPhoneNumber)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherCard;
